import AssafAlon from './../static/img/WhoAreWe/assaf.png'
import OrtalOved from './../static/img/WhoAreWe/ortal.png'
import OdedAlyagon from './../static/img/WhoAreWe/oded.png'
import ShayHalperson from './../static/img/WhoAreWe/shay.png'
import RamiOrbach from './../static/img/WhoAreWe/rami.png'
import RonitEpstein from './../static/img/WhoAreWe/ronit.png'
import AsherElgar from './../static/img/WhoAreWe/asher.png'
import JordanPons from './../static/img/WhoAreWe/jordan.png'
import MaxSvidlo from './../static/img/WhoAreWe/max.png'
import DimitryBukky from './../static/img/WhoAreWe/dimtry.png'
import AlexGorbatovsky from './../static/img/WhoAreWe/alex.png'
import NahumGlik from './../static/img/WhoAreWe/nahum.png'
import ItCouldBeYou from './../static/img/WhoAreWe/hippo.png'


const data = [
  {
    "name": "Assaf Alon",
    "role": "Owner & CEO",
    "image": AssafAlon
  },
  {
    "name": "Michal Liubimov",
    "role": "Administration"
  },  {
    "name": "Oded Alyagon",
    "role": "UI Designer",
    "image": OdedAlyagon
  },
  {
    "name": "Ortal Oved",
    "role": "UX/UI Designer",
    "image": OrtalOved
  },

  {
    "name": "Shay Halperson",
    "role": "Android developer",
    "image": ShayHalperson
  },
  {
    "name": "Dmitry Bukky",
    "role": "Full Stack Developer",
    "image": DimitryBukky
  },
  {
    "name": "Nahum Glik",
    "role": "iOS developer",
    "image": NahumGlik
  },
  {
    "name": "Rami Orbach",
    "role": "Android developer",
    "image": RamiOrbach
  },
  {
    "name": "Ronit Epstein",
    "role": "Android developer",
    "image": RonitEpstein
  },
  {
    "name": "Israel Bicher",
    "role": "Full-stack developer",

  },
  {
    "name": "Tal Meisler",
    "role": "QA Software Tester",

  },
  {
    "name": "Asher Elgar",
    "role": "iOS developer",
    "image": AsherElgar
  },
  {
    "name": "Jordan Pons",
    "role": "iOS developer",
    "image": JordanPons
  },
  {
    "name": "Max Svidlo",
    "role": "Full Stack Developer",
    "image": MaxSvidlo
  },
  {
    "name": "Alex Gorbatovsky",
    "role": "Web developer",
    "image": AlexGorbatovsky
  },
  {
    "name": "It could be you!",
    "role": "Send your CV",
    "image": ItCouldBeYou
  }
]

export default data;



// WEBPACK FOOTER //
// ./src/workersData.js